import { render, staticRenderFns } from "./mypercentage.vue?vue&type=template&id=618e221f&scoped=true"
import script from "./mypercentage.vue?vue&type=script&lang=js"
export * from "./mypercentage.vue?vue&type=script&lang=js"
import style0 from "./mypercentage.vue?vue&type=style&index=0&id=618e221f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e221f",
  null
  
)

export default component.exports